import { useQuery } from '@tanstack/react-query';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ExperimentDetailPage } from '@/features/ml/experiments/experiment-detail-page';
import { experimentQuery } from '@/features/ml/experiments/experiment-api';
import { isExperimentTab, type ExperimentTab } from '@/features/ml/experiments/experiment-tabs';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Détail d'une expérience (porting README #81). L'onglet actif vit dans l'URL (`?tab=summary`). */
export const Route = createFileRoute('/$tenant/projects/$projectId/experiments/$experimentId/')({
  validateSearch: (search: Record<string, unknown>): { tab: ExperimentTab } => ({
    tab: isExperimentTab(search['tab']) ? search['tab'] : 'runs',
  }),
  component: ExperimentRoute,
});

function ExperimentRoute() {
  const { tenant, projectId, experimentId } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  const experiment = useQuery(experimentQuery(tenant, projectId, experimentId));
  return (
    <ConsoleShell
      tenantId={tenant}
      projectId={projectId}
      activeItem="experiments"
      crumbs={[
        { label: t('nav.items.experiments') },
        { label: experiment.data?.name ?? experimentId, mono: true },
      ]}
    >
      <ExperimentDetailPage
        tenantId={tenant}
        projectId={projectId}
        experimentId={experimentId}
        tab={tab}
        onTabChange={(next) => void navigate({ search: { tab: next }, replace: true })}
      />
    </ConsoleShell>
  );
}
